import { createSlice } from '@reduxjs/toolkit';
import { initStateServiceUpdate, reducerServiceUpdate } from '../actions/service/serviceUpdate';

import { reducerGamePartnerSwitchActive } from '../actions/game/gamePartnerSwitchActive';
import { initStateServiceSwitchActive, reducerServiceSwitchActive } from '../actions/service/serviceSwtichActive';
import { initStateServiceGenerateKey, reducerServiceGenerateKey } from '../actions/service/serviceGenerateKey';
import { initStateServiceList, reducerServiceList } from '../actions/service/serviceList';

export const initialState = {
  ...initStateServiceUpdate,
  ...initStateServiceSwitchActive,
  ...initStateServiceGenerateKey,
  ...initStateServiceList,
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    resetServiceUpdate(state, action) {
      state.serviceUpdate = initStateServiceUpdate.serviceUpdate;
    },
    resetServiceGenerateKey(state, action) {
      state.serviceGenerateKey = initStateServiceGenerateKey.serviceGenerateKey;
    },
  },
  extraReducers: {
    ...reducerServiceUpdate,
    ...reducerServiceSwitchActive,
    ...reducerServiceGenerateKey,
    ...reducerServiceList,
  },
});
export const { resetServiceGenerateKey, resetServiceUpdate } = serviceSlice.actions;
export const serviceReducer = serviceSlice.reducer;
